import isEmpty from 'lodash/isEmpty'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import {Observable} from 'rxjs/Observable'
import * as App from '../../app'
import * as Flash from '../../components/flash-message'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import * as Pager from '../../components/pager'
import * as Sortable from '../../components/sortable'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

const onEnter = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.CONTENT_POSTS_URL))
  .map(store.getState)
  .map(({app, posts}) => ({
    posts: {
      ...posts,
      view: {
        ...posts.view,
        ...Utils.queryParamsToState(app.urlParams),
      },
    },
    selectedCommunity: app.selectedCommunity,
    viewState: {
      dateSelect: posts.view.dateSelect,
      filter: {
        ...IsActive.FILTER_STATUS_ACTIVE,
        ...posts.view.filter,
      },
      page: posts.page,
      sort: posts.view.sort,
      ...Utils.queryParamsToState(app.urlParams),
    },
  }))
  .mergeMap(({selectedCommunity, viewState, posts}: any) => [
    Actions.updateUI(viewState),
    Actions.fetchPosts(
      selectedCommunity,
      {
        ...Utils.fetchQueryParamsFromState(posts),
      },
     ),
    Actions.fetchRecentIssues(
      selectedCommunity,
      viewState,
    ),
  ])

export const filterChange = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(
    IsActive.filterStatusConstant(Constants.FETCH_POSTS),
    IsActive.filterStatusConstant(Constants.CHANGE_DATE_SELECT),
    Pager.goToPageConstant(Constants.FETCH_POSTS),
  )
  .filter(() => history.location.pathname.startsWith(Menu.CONTENT_POSTS_URL))
  .map(store.getState)
  .mergeMap(({app, posts}) => [
    App.updateUrlParams(Utils.fetchQueryParamsFromState(posts)),
    Actions.fetchPosts(
      app.selectedCommunity,
      {
        ...Utils.fetchQueryParamsFromState(posts),
      },
    ),
  ])

export const serverSortChange = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(Sortable.sortTableConstant(Constants.FETCH_POSTS_SORTED))
.mergeMap((action: Actions.PostsServerSortAction) => {
  const app = store.getState().app
  let posts = store.getState().posts
  posts = {
    ...posts,
    view: {
      ...posts.view,
      sort: [{
        dir: action.options.value && action.options.value.length ? action.options.value[0].dir : 'desc',
        field: action.options.value && action.options.value.length ? action.options.value[0].field : 'created',
      }],
    },
  }
  return [
    Actions.sortPosts(action.options),
    App.updateUrlParams(Utils.fetchQueryParamsFromState(posts)),
    Actions.fetchPosts(
      app.selectedCommunity,
      {
        ...Utils.fetchQueryParamsFromState(posts),
      },
    ),
  ]
})

const onSaveRequest = (
  action$: ReduxObservable.ActionsObservable<Form.SaveAction<Types.Post>>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(Actions.FormConstants[Form.SAVE])
    .map((action) => Actions.create(store.getState().app.selectedCommunity, action.value))

const addPostSuccess = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(
  Request.successConstant(Constants.ADD_POST))
  .mergeMap((action) => {
    const {app, posts} = store.getState()
    const baseActions: any[] = [
      Actions.FormActions[Form.SAVE_COMPLETE](),
      Actions.fetchPosts(
        app.selectedCommunity,
        {
          ...Utils.fetchQueryParamsFromState(posts),
        },
      ),
    ];
    if (posts.modal && posts.modal.isOpen === true) {
      let expectedFields: string[] = []
      if (posts.form.fields.title === '') {
        expectedFields = expectedFields.concat('Title')
      }
      if (posts.form.fields.site_name === '') {
        expectedFields = expectedFields.concat('Source')
      }
      if (posts.form.fields.description === '') {
        expectedFields = expectedFields.concat('Description')
      }
      if (!isEmpty(expectedFields)) {
        return [Flash.showFlashError('Expected fields: ' + expectedFields.join(','))].concat(baseActions)
      }
    } else {
      if (action.requestAction.options.payload.id) {
        return [Flash.showFlashMessage('Post Updated!')].concat(baseActions)
      }
      return [Flash.showFlashMessage('Post created!')].concat(baseActions)
    }
  },
)

type AddPostErrorEpic = (action$: ReduxObservable.ActionsObservable<any>) =>
  Observable<Form.SaveCompleteAction>
const addPostError: AddPostErrorEpic = (action$) =>
  action$.ofType(Request.errorConstant(Constants.ADD_POST))
  .map(Actions.FormActions[Form.SAVE_COMPLETE])

export const epic = ReduxObservable.combineEpics(
  filterChange,
  Form.validateForm('posts', Actions.FormConstants, Actions.FormActions, Constants.FormValidators),
  IsActive.createStatusUpdateEpic(Constants.UPDATE_POST, Actions.update),
  onEnter,
  addPostError,
  onSaveRequest,
  Pager.pageChangeEpic(Constants.FETCH_POSTS),
  addPostSuccess,
  serverSortChange,
)



// WEBPACK FOOTER //
// ./src/pages/posts/epic.ts